/**
 * @purpose: mengelola tampilan master bagging untuk CRUD Hub dan Destination/Kota.
 * @called_by: views/app_master/bagging_master.html.
 * @deps: urlServices, toaster, modalService.
 * @public: controller AngularJS baggingMasterCtrl.
 * @side_effects: memanggil API master bagging, mengubah state form, dan menampilkan konfirmasi hapus.
 */
app.controller('baggingMasterCtrl', function ($scope, urlServices, toaster, modalService) {
    var hubApi = 'api/bagging-master/hubs';
    var destinationApi = 'api/bagging-master/destinations';

    $scope.hubRows = [];
    $scope.hubLoading = false;
    $scope.hubSaving = false;
    $scope.hubFilter = '';
    $scope.destinationRows = [];
    $scope.destinationLoading = false;
    $scope.destinationSaving = false;
    $scope.destinationFilter = '';
    $scope.destinationFilterHubId = '';

    function normalizeTextValue(value) {
        return String(value === undefined || value === null ? '' : value).trim();
    }

    function normalizeError(err, fallbackMessage) {
        if (!err) {
            return fallbackMessage || 'Error tidak terdeteksi';
        }
        if (err.err) {
            return err.err;
        }
        if (err.message) {
            return err.message;
        }

        return String(err);
    }

    function resetHubForm() {
        $scope.hubForm = {
            Id: 0,
            HubId: '',
            ProvinceId: '',
            HubName: '',
            GeoId: '',
            GeoName: '',
            Place: '',
            Lat: '',
            Long: ''
        };
    }

    function resetDestinationForm() {
        $scope.destinationForm = {
            Id: 0,
            DestId: '',
            HubId: '',
            City: '',
            SubDistrict: '',
            DestName: '',
            IsOrigin: false,
            HubId2: ''
        };
    }

    function loadHubs() {
        $scope.hubLoading = true;
        return urlServices.ambilData(hubApi + '?limit=5000&pg=1', {}, function (err, result) {
            $scope.hubLoading = false;
            if (err) {
                return toaster.pop('error', 'Master Bagging', normalizeError(err, 'Gagal memuat master hub'));
            }

            $scope.hubRows = result && result.rows ? result.rows : [];
        });
    }

    function loadDestinations() {
        var query = '?limit=5000&pg=1';

        if ($scope.destinationFilterHubId) {
            query += '&hubId=' + encodeURIComponent($scope.destinationFilterHubId);
        }

        $scope.destinationLoading = true;
        return urlServices.ambilData(destinationApi + query, {}, function (err, result) {
            $scope.destinationLoading = false;
            if (err) {
                return toaster.pop('error', 'Master Bagging', normalizeError(err, 'Gagal memuat master kota'));
            }

            $scope.destinationRows = result && result.rows ? result.rows : [];
        });
    }

    $scope.editHub = function (row) {
        $scope.hubForm = {
            Id: row.id || 0,
            HubId: row.hub_id || '',
            ProvinceId: row.province_id || '',
            HubName: row.hub_name || '',
            GeoId: row.geo_id || '',
            GeoName: row.geo_name || '',
            Place: row.place || '',
            Lat: row.lat || '',
            Long: row.long || ''
        };
    };

    $scope.editDestination = function (row) {
        $scope.destinationForm = {
            Id: row.id || 0,
            DestId: row.dest_id || '',
            HubId: row.hub_id || '',
            City: row.city || '',
            SubDistrict: row.sub_disctrict || '',
            DestName: row.dest_name || '',
            IsOrigin: row.is_origin === true,
            HubId2: row.hub_id2 || ''
        };
    };

    $scope.cancelHub = function () {
        resetHubForm();
    };

    $scope.cancelDestination = function () {
        resetDestinationForm();
    };

    $scope.saveHub = function () {
        var payload = angular.copy($scope.hubForm);
        var requestMethod = payload.Id ? urlServices.updateData : urlServices.simpanData;

        if (!normalizeTextValue(payload.HubId)) {
            return toaster.pop('warning', 'Master Bagging', 'Kode hub wajib diisi');
        }
        if (!normalizeTextValue(payload.ProvinceId)) {
            return toaster.pop('warning', 'Master Bagging', 'Province ID wajib diisi');
        }
        if (!normalizeTextValue(payload.HubName)) {
            return toaster.pop('warning', 'Master Bagging', 'Nama hub wajib diisi');
        }

        $scope.hubSaving = true;
        return requestMethod(hubApi, payload, function (err) {
            $scope.hubSaving = false;
            if (err) {
                return toaster.pop('error', 'Master Bagging', normalizeError(err, 'Gagal menyimpan hub'));
            }

            toaster.pop('success', 'Master Bagging', 'Master hub berhasil disimpan');
            resetHubForm();
            loadHubs();
            loadDestinations();
        });
    };

    $scope.saveDestination = function () {
        var payload = angular.copy($scope.destinationForm);
        var requestMethod = payload.Id ? urlServices.updateData : urlServices.simpanData;

        if (!normalizeTextValue(payload.DestId)) {
            return toaster.pop('warning', 'Master Bagging', 'Kode kota wajib diisi');
        }
        if (!normalizeTextValue(payload.HubId)) {
            return toaster.pop('warning', 'Master Bagging', 'Tujuan hub wajib diisi');
        }
        if (!normalizeTextValue(payload.DestName)) {
            return toaster.pop('warning', 'Master Bagging', 'Nama destination wajib diisi');
        }

        payload.IsOrigin = payload.IsOrigin ? 1 : 0;
        $scope.destinationSaving = true;

        return requestMethod(destinationApi, payload, function (err) {
            $scope.destinationSaving = false;
            if (err) {
                return toaster.pop('error', 'Master Bagging', normalizeError(err, 'Gagal menyimpan kota'));
            }

            toaster.pop('success', 'Master Bagging', 'Master kota berhasil disimpan');
            resetDestinationForm();
            loadDestinations();
        });
    };

    $scope.deleteHub = function (row) {
        modalService.showModal({}, {
            closeButtonText: 'Batal',
            actionButtonText: 'Hapus',
            headerText: 'Hapus Hub',
            bodyText: 'Hapus hub ' + (row && row.hub_id ? row.hub_id : '-') + '?'
        }).then(function (confirmed) {
            if (!confirmed) {
                return;
            }

            return urlServices.hapusData(hubApi + '/' + encodeURIComponent(row.id), {}, function (err) {
                if (err) {
                    return toaster.pop('error', 'Master Bagging', normalizeError(err, 'Gagal menghapus hub'));
                }
                if (Number($scope.hubForm.Id || 0) === Number(row.id || 0)) {
                    resetHubForm();
                }
                toaster.pop('success', 'Master Bagging', 'Master hub berhasil dihapus');
                loadHubs();
                loadDestinations();
            });
        });
    };

    $scope.deleteDestination = function (row) {
        modalService.showModal({}, {
            closeButtonText: 'Batal',
            actionButtonText: 'Hapus',
            headerText: 'Hapus Kota',
            bodyText: 'Hapus kota ' + (row && row.dest_id ? row.dest_id : '-') + '?'
        }).then(function (confirmed) {
            if (!confirmed) {
                return;
            }

            return urlServices.hapusData(destinationApi + '/' + encodeURIComponent(row.id), {}, function (err) {
                if (err) {
                    return toaster.pop('error', 'Master Bagging', normalizeError(err, 'Gagal menghapus kota'));
                }
                if (Number($scope.destinationForm.Id || 0) === Number(row.id || 0)) {
                    resetDestinationForm();
                }
                toaster.pop('success', 'Master Bagging', 'Master kota berhasil dihapus');
                loadDestinations();
            });
        });
    };

    $scope.refreshDestinations = function () {
        loadDestinations();
    };
    
    $scope.refreshHubs = function () {
        loadHubs();
    };

    resetHubForm();
    resetDestinationForm();
    loadHubs();
    loadDestinations();
});